// extracted by mini-css-extract-plugin
module.exports = {"container":"NewOrderCard_container__yqvnO","placeholderWrapper":"NewOrderCard_placeholderWrapper__8eTaf"};